import { Navigate, Route, Routes } from "react-router-dom";
import DashboardPage from "./pages/admin/DasboardPage";
import UsersPage from "./pages/admin/Users/UsersPages";
import TransactionsPage from "./pages/admin/Transactions/TransactionsPages";
import AlertsPage from "./pages/admin/AlertsPage";
import RevenuePage from "./pages/admin/Revenues/RevenuesPage";
import CountriesPage from "./pages/admin/CountriesPage";
import RatesPage from "./pages/admin/PromoCodePage";
import AddCountryPage from "./pages/admin/AddCountryPage";
import SettingsPage from "./pages/admin/SettingsPage";
import NotificationsPage from "./pages/admin/NotificationsPage";
import CountryTransfertsPage from "./pages/admin/CountryTransfertsPage";
import WalletsPage from "./pages/admin/WalletsPage";
import InteracEmailsPage from "./pages/admin/InteracEmailsPage";
import DashboardAuditPage from "./pages/admin/DashboardAuditPage";
import SystemAnnouncementsPage from "./pages/admin/SystemAnnouncementsPage";
import ChatPage from "./pages/admin/ChatPage";
import WithdrawalRequestsPage from "./pages/admin/WithdrawalRequestsPage";
import SEO from "../../components/common/ui/SEO";
import UserTransactionsPage from "./pages/admin/Users/UserTransactions";
import BuyAndSellOverviewPage from "./pages/admin/BuyAndSell/SalesPage";
import ProfitTrackingPage from "./pages/admin/ProfitTracking/ProfitTrackingPage";
import AmbassadorsPage from "./pages/admin/ProfitTracking/AmbassadorsPage";
import BankNav from "./navigation/banque/BankTransfertsNav";
import useAdminChatPush from "./hooks/chat/useAdminChatPush";
import { UpdateUserPage } from "./pages/admin/Users/UpdateUserPage";
import NewUserPage from "./pages/admin/Users/NewUserPage";
import TasksPage from "./pages/admin/Tasks/TasksPage";
import CmrChinaTransfersPage from "./pages/admin/CmrChinaTransfersPage";

function IziLifePayNav() {
  // Notifications push des nouveaux messages support, actives sur toutes les
  // pages admin et non seulement sur la page chat.
  useAdminChatPush();

  return (
    <>
      <SEO
        title="IZILIFE-PAY | Dashboard Admin"
        favicon="/EASYPAY_icon.png"
        description="Tableau de bord IZILIFE-PAY : suivi des utilisateurs, transactions et revenus ."
      />

      <Routes>
        <Route path="*" element={<Navigate to="/izilife-pay/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/update-user" element={<UpdateUserPage />} />
        <Route path="/new-user" element={<NewUserPage />} />
        <Route path="/user-transactions/:userId" element={<UserTransactionsPage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/revenue" element={<RevenuePage />} />
        <Route path="/countries" element={<CountriesPage />} />
        <Route path="/promos" element={<RatesPage />} />
        <Route path="/new-country" element={<AddCountryPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/concurrents" element={<Navigate to="/izilife-pay/settings?tab=concurrents" replace />} />
        <Route path="/country-transferts" element={<CountryTransfertsPage />} />
        <Route path="/wallets" element={<WalletsPage />} />
        <Route path="/interac-emails" element={<InteracEmailsPage />} />
        <Route path="/audit-logs" element={<DashboardAuditPage />} />
        <Route path="/tasks" element={<TasksPage />} />

        <Route path="/system-announcements" element={<SystemAnnouncementsPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/withdrawal-requests" element={<WithdrawalRequestsPage />} />
        <Route path="/profit-tracking/ambassadors" element={<AmbassadorsPage />} />
        <Route path="/profit-tracking" element={<ProfitTrackingPage />} />
        <Route path="/buy-and-sell" element={<BuyAndSellOverviewPage />} />
        <Route path="/bank-transferts/*" element={<BankNav />} />
        <Route path="/cameroun-chine" element={<CmrChinaTransfersPage />} />
      </Routes>
    </>
  );
}

export default IziLifePayNav;
